export default __webpack_public_path__ + "static/our-work-8a0f8390f7bcad25cf193afa4429ffe4.png";